class ProductResize extends HTMLElement {
  constructor() {
    super();
    //Dropdown variables
    this.checkbox = this.querySelector('[data-resize-checkbox]');
    this.options = this.querySelector('[data-resize-options]');
    this.optionsInput = this.options.querySelector('select');
    this.resizeType = this.querySelector('[data-resize-type]');
    this.originalIndex = this.optionsInput.selectedIndex;
    this.optionsHaveBeenOpened = false;

    //Dropdown event listeners
    this.checkbox.addEventListener('change', this.toggleOptions.bind(this));
    this.options.addEventListener('change', this.sizeChangehandler.bind(this));

    //Carousel variables
    this.prevBtn = this.querySelector('#prev');
    this.nextBtn = this.querySelector('#next');
    this.slides = Array.from(this.querySelectorAll('button.slide'));
    this.curItemDetails = this.querySelector('.resize-carousel__cur-item-details')
    this.curItemDetailsText = this.curItemDetails.querySelector('p');
    this.activeSlideNo = 0;
    this.pixelGapBetweenSlides = 10;
    this.sliderContainer = this.querySelector('#slider-container');

    //Carousel event listeners
    let scrollTimeout;
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.isMouseInteracting = true;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => this.moveCarousel(this.activeSlideNo - 1), 10);
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.isMouseInteracting = true;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => this.moveCarousel(this.activeSlideNo + 1), 10);
      });
    }
    this.sliderContainer.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      //If the user scrolls update the active slide to reflect it 
      scrollTimeout = setTimeout(() => this.handleCarouselScroll(), 200);
    });
    this.slides.forEach((slide, i) => {
      //If a slide is clicked, navigate to it 
      slide.addEventListener('click', () => {
        this.isMouseInteracting = true;
        this.moveCarousel(i, 'slideClick');
      });
    });


    this.mouseIsDown = false;
    let startX;
    let scrollLeft;

    this.sliderContainer.addEventListener('mousedown', (e) => {
      this.isMouseInteracting = true;
      this.mouseIsDown = true;
      startX = e.pageX - this.sliderContainer.offsetLeft;
      scrollLeft = this.sliderContainer.scrollLeft;
    });

    this.sliderContainer.addEventListener('mouseleave', () => {
      this.mouseIsDown = false;
    });

    this.sliderContainer.addEventListener('mouseup', () => {
      this.mouseIsDown = false;
    });

    this.sliderContainer.addEventListener('mousemove', (e) => {
      this.isMouseInteracting = true;
      if (!this.mouseIsDown) return;
      e.preventDefault();
      const x = e.pageX - this.sliderContainer.offsetLeft;
      const walk = (x - startX) * 2; // adjust swipe speed
      this.sliderContainer.scrollLeft = scrollLeft - walk;
    });
  }

  toggleOptions() {
    if (this.checkbox.checked) {
      this.options.classList.remove('is-hidden');
      this.options.querySelector('select').disabled = false;
      this.resizeType.disabled = false;
      if (!this.optionsHaveBeenOpened) {
        //If the options are being opened for the first time, update the carousel to the correct slide (Had to wait until the options are open so the bounding box would work)
        const posOfCurSize = Number(this.querySelector('.slide--active').dataset.index);
        this.moveCarousel(posOfCurSize);
      }
      this.optionsHaveBeenOpened = true;
    } else {
      this.options.classList.add('is-hidden');
      this.options.querySelector('select').disabled = true;
      this.resizeType.disabled = true;
    }
  }

  sizeChangehandler() {
    const newIndex = this.optionsInput.selectedIndex;
    if (newIndex !== this.originalIndex) {
      // dropdown value has changed
      if (newIndex > this.originalIndex) {
        // selection was moved down
        this.resizeType.value = 'Increase'
      } else {
        // selection was moved up
        this.resizeType.value = 'Decrease'
      }
    }
  }

  moveCarousel(newActiveSlideNo, reasonForMove) {

    if (reasonForMove == 'slideClick') {
      this.isMouseNavigation = true;
    }

    this.updateActiveCarouselItem(newActiveSlideNo);

    //Disable prev btn if at the start 
    this.prevBtn.disabled = this.activeSlideNo === 0;
    //Disable next btn if at the end
    this.nextBtn.disabled = this.activeSlideNo === this.slides.length - 1;

    var slideWidth = this.slides[0].getBoundingClientRect().width + this.pixelGapBetweenSlides;
    this.sliderContainer.scrollLeft = slideWidth * this.activeSlideNo;

    //If the carousel has moved for the first time, now give it smooth scrolling for the future
    if (!this.optionsHaveBeenOpened) {
      this.sliderContainer.style.scrollBehavior = "smooth";
    }
  }

  updateActiveCarouselItem(newActiveSlideNo) {
    this.activeSlideNo = newActiveSlideNo
    if (this.querySelector('.slide--active')) this.querySelector('.slide--active').classList.remove('slide--active');
    this.querySelector(`#slide--${this.activeSlideNo}`).classList.add('slide--active');

    const newSizeValue = this.querySelector(`#slide--${this.activeSlideNo}`).dataset.value;
    //Update carousel text
    this.curItemDetailsText.innerText = newSizeValue;
    if (!newSizeValue.includes('Original')) this.curItemDetailsText.ariaLabel = `You've selected to resize the ring to ${newSizeValue}`;

    //Update dropdown selection
    this.optionsInput.value = newSizeValue;
    this.sizeChangehandler();

    //Make sure the SVG to point to the newly selected slide is there
    this.curItemDetails.classList.remove('resize-carousel__cur-item-details--hide-svg');
  }

  handleCarouselScroll() {
    var slideWidth = this.slides[0].getBoundingClientRect().width + this.pixelGapBetweenSlides;
    var scrollPosition = this.sliderContainer.scrollLeft;
    var newActiveSlide = Math.round(scrollPosition / slideWidth);

    //If the scrolling was due to the user navigating via keyboard (tabbing between slides), and not by using the mouse, don't move the carousel
    if (document.activeElement.classList.contains('resize-carousel__item') && document.activeElement.id !== `slide--${this.activeSlideNo}` && !this.isMouseInteracting) {
      this.curItemDetails.classList.add('resize-carousel__cur-item-details--hide-svg');
    } else {
      this.moveCarousel(newActiveSlide);
    }
    //Now the carousel has stopped moving, make sure it is clear the mouse isn't interacting any more
    this.isMouseInteracting = false;
  }
}
if (!customElements.get('product-resize')) {
  customElements.define('product-resize', ProductResize);
}